import { render, staticRenderFns } from "./EnterActivation.vue?vue&type=template&id=586b80b4"
import script from "./EnterActivation.vue?vue&type=script&lang=js"
export * from "./EnterActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports